import { Component, EventEmitter, Input, NgModule, NgZone, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { extend } from 'lodash';
import * as _ from 'lodash';

/**
 * JSONEditor component
 * Usage :
 *  <json-editor [(ngModel)]="data" [config]="{...}"></json-editor>
 */
var JSONEditorComponent = (function () {
    /**
     * Constructor
     * @param {?} zone
     */
    function JSONEditorComponent(zone) {
        this.change = new EventEmitter();
        this.editable = new EventEmitter();
        this.error = new EventEmitter();
        this.zone = zone;
    }
    /**
     * On component destroy
     * @return {?}
     */
    JSONEditorComponent.prototype.ngOnDestroy = function () {
        this.destroy();
    };
    /**
     * On component view init
     * @return {?}
     */
    JSONEditorComponent.prototype.ngAfterViewInit = function () {
        this.editorInit(this.config || {});
    };
    /**
     * Editor init
     * @param {?=} config
     * @return {?}
     */
    JSONEditorComponent.prototype.editorInit = function (config) {
        if (config === void 0) { config = {}; }
        var /** @type {?} */ self = this;
        var /** @type {?} */ defaultConfig = {
            onChange: function () {
                var /** @type {?} */ value = self.instance.get();
                self.updateValue(value);
            },
        };
        if (self.editable.observers.length > 0) {
            defaultConfig.onEditable = function (v) {
                self.editable.emit(v);
            };
        }
        if (self.error.observers.length > 0) {
            defaultConfig.onError = function (v) {
                self.error.emit(v);
            };
        }
        var /** @type {?} */ newConfig = extend(config, defaultConfig);
        this.instance = new JSONEditor(this.host.nativeElement, newConfig);
    };
    Object.defineProperty(JSONEditorComponent.prototype, "value", {
        /**
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            if (v !== this._value) {
                this._value = v;
                this.onChange(v);
            }
        },
        enumerable: true,
        configurable: true
    });
    
    /**
     * Value update process
     * @param {?} value
     * @return {?}
     */
    JSONEditorComponent.prototype.updateValue = function (value) {
        var _this = this;
        this.zone.run(function () {
            _this.value = value;
            _this.onChange(value);
            _this.onTouched();
            _this.change.emit(value);
        });
    };
    /**
     * Implements ControlValueAccessor
     * @param {?} value
     * @return {?}
     */
    JSONEditorComponent.prototype.writeValue = function (value) {
        this._value = value;
        if (this.instance) {
            this.instance.set(value);
        }
    };
    /**
     * @param {?} _
     * @return {?}
     */
    JSONEditorComponent.prototype.onChange = function (_$$1) {
    };
    /**
     * @return {?}
     */
    JSONEditorComponent.prototype.onTouched = function () {
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    JSONEditorComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    JSONEditorComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Json editor method
     *
     * @return {?}
     */
    JSONEditorComponent.prototype.expandAll = function () {
        if (this.instance) {
            this.instance.expandAll();
        }
    };
    /**
     * @return {?}
     */
    JSONEditorComponent.prototype.collapseAll = function () {
        if (this.instance) {
            this.instance.collapseAll();
        }
    };
    /**
     * @return {?}
     */
    JSONEditorComponent.prototype.destroy = function () {
        if (this.instance) {
            this.instance.destroy();
        }
    };
    /**
     * @return {?}
     */
    JSONEditorComponent.prototype.focus = function () {
        if (this.instance) {
            this.instance.focus();
        }
    };
    /**
     * @param {?} mode
     * @return {?}
     */
    JSONEditorComponent.prototype.setMode = function (mode) {
        if (this.instance) {
            this.instance.setMode(mode);
        }
    };
    /**
     * @param {?} name
     * @return {?}
     */
    JSONEditorComponent.prototype.setName = function (name) {
        if (this.instance) {
            this.instance.setName(name);
        }
    };
    /**
     * @param {?} schema
     * @return {?}
     */
    JSONEditorComponent.prototype.setSchema = function (schema) {
        if (this.instance) {
            this.instance.setSchema(schema);
        }
    };
    /**
     * @param {?} jsonString
     * @return {?}
     */
    JSONEditorComponent.prototype.setText = function (jsonString) {
        if (this.instance) {
            this.instance.setText(jsonString);
        }
    };
    /**
     * @return {?}
     */
    JSONEditorComponent.prototype.getMode = function () {
        if (this.instance) {
            return this.instance.getMode();
        }
    };
    /**
     * @return {?}
     */
    JSONEditorComponent.prototype.getName = function () {
        if (this.instance) {
            return this.instance.getName();
        }
    };
    /**
     * @return {?}
     */
    JSONEditorComponent.prototype.getText = function () {
        if (this.instance) {
            return this.instance.getText();
        }
    };
    return JSONEditorComponent;
}());
JSONEditorComponent.decorators = [
    { type: Component, args: [{
                selector: 'json-editor',
                exportAs: 'json-modal',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(function () { return JSONEditorComponent; }),
                        multi: true
                    }
                ],
                template: "\n        <div #host></div>",
            },] },
];
/**
 * @nocollapse
 */
JSONEditorComponent.ctorParameters = function () { return [
    { type: NgZone, },
]; };
JSONEditorComponent.propDecorators = {
    'config': [{ type: Input },],
    'change': [{ type: Output },],
    'editable': [{ type: Output },],
    'error': [{ type: Output },],
    'host': [{ type: ViewChild, args: ['host',] },],
};

/**
 * JSONEditorModule
 */
var JSONEditorModule = (function () {
    function JSONEditorModule() {
    }
    /**
     * @return {?}
     */
    JSONEditorModule.forRoot = function () {
        return {
            ngModule: JSONEditorModule,
        };
    };
    return JSONEditorModule;
}());
JSONEditorModule.decorators = [
    { type: NgModule, args: [{
                imports: [],
                declarations: [
                    JSONEditorComponent,
                ],
                exports: [
                    JSONEditorComponent,
                ]
            },] },
];
/**
 * @nocollapse
 */
JSONEditorModule.ctorParameters = function () { return []; };

export { JSONEditorModule, JSONEditorComponent };



//////////////////
// WEBPACK FOOTER
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/ngx-jsoneditor/index.js
// module id = ../../../../ngx-jsoneditor/index.js
// module chunks = 4